<micro-lookup domain="smsc" obj="smscManagers" url="/smsc/smscManagers" [key]="smscManagerId"></micro-lookup>
